/* eslint-disable */
import * as React from "react";
import { SlideContext } from "../Context";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { useChartData } from "../data/useChartData";
import { useHighchartTransformer } from "../transformers/useHighchartTransformer";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart from "../../../../charts/components/HighchartsChart";
import { ComponentContextReadyState } from "@sa/rep-core";
import { ComponentTitle } from "../../../components/ComponentTitle";
import { ComponentFootnote } from "../../../components/ComponentFootnote";
import { useDictionaryItem, useParameter, useSubscriptionSource } from "../../../shared";
import { useExportSource } from "../hooks/useExportSource";
import { dictionaryService } from "../../../dataFlow";

export const ComponentChartUSD: React.FC<{ context: SlideContext }> = (props) => {
  const context = props.context;
  const olapResult = useHookSubscribe(null, context.olapResultUSD$);
  const source = useHookSubscribe(null, context.sources$);
  const loading = useHookSubscribe(true, context.loading$);
  const [methodId] = useParameter<number>("@method");
  const [_, methodNameLocale] = useDictionaryItem(dictionaryService, "slides-methods", methodId);
  const methodName: string = methodNameLocale ? (methodNameLocale as any)[9] : "";
  const isMethodIndex = methodId === 2;
  useExportSource(source);
  useSubscriptionSource(source);

  const chartData = useChartData(olapResult);
  const highchartData = useHighchartTransformer(chartData, "USD/mt");

  if (window["exportMode"]) {
    window["exportReady"] = highchartData && context.readyState !== ComponentContextReadyState.Loading;
  }
  if (loading || !highchartData || context.readyState === ComponentContextReadyState.Loading) {
    return <ComponentPreloader />;
  }
  const empty = <span>&nbsp;</span>;
  return (
    <>
      <ComponentTitle>Price {methodName.toLowerCase()} in USD</ComponentTitle>
      <ComponentSourcetitle>Source: {source}</ComponentSourcetitle>
      <ComponentFootnote>{isMethodIndex ? "%" : "USD/mt"}</ComponentFootnote>
      <HighchartsChart data={highchartData} loader={<ComponentPreloader />} />
      <ComponentFootnote>{!isMethodIndex ? "* Crude oil data is reported in currency/barrel" : empty}</ComponentFootnote>
    </>
  );
};
